import {Button} from '@mantine/core';
import {
  ENTRY_BUTTON_ID,
  ENTRY_BUTTON_TEXT_SIZE,
  GradientEntryButton,
} from '../../../../shared/components/EntryButton/GradientEntryButton';
import {buildCompanyFollowGtmContent} from '../../../../shared/services/buildCompanyFollowGtmContent';
import {FollowCompanyButton} from '../FollowButton';

/**
 * 画面下に最大幅を使って配置するボタン
 */
export const EntryButtonSP = ({
  entryURL,
  registrationURL,
  companyId,
  companyName,
  isFollowed,
  followCount,
  onFollow,
}: {
  entryURL?: string;
  registrationURL?: string;
  companyId: number;
  companyName?: string;
  isFollowed: boolean;
  followCount: number;
  onFollow: () => void | Promise<void>;
}) => {
  const hasEntryButton = Boolean(entryURL || registrationURL);

  return (
    <div className="pc:hidden fixed bottom-0 w-[100vw] p-12 bg-white shadow-footer bg-opacity-80">
      <div className={hasEntryButton ? 'mb-8' : ''}>
        <FollowCompanyButton
          companyId={companyId}
          initial={{
            followerCount: followCount,
            isFollowed,
          }}
          hasPlus={false}
          className="rounded-[8px] w-full"
          controlled={{
            isFollowed,
            followCount,
            onFollow,
          }}
          dataGtmContent={buildCompanyFollowGtmContent({
            companyId,
            companyName: companyName ?? '',
            location: 'company-detail-sp-fixed',
          })}
        />
      </div>
      {hasEntryButton && (
        <div className="flex gap-8">
          {registrationURL && registrationURL.length > 0 && (
            <Button
              className={`bg-white text-primary-1 border-primary-1 rounded-[8px] ${entryURL ? 'w-[48%]' : 'w-[100%]'} mx-auto block pc:hover:ease-in-out pc:hover:duration-300 text-md h-52`}
              onClick={() =>
                window.open(
                  `${registrationURL}`,
                  '_blank',
                  'noopener,noreferrer',
                )
              }
            >
              説明会を予約
            </Button>
          )}
          {entryURL && entryURL.length > 0 && (
            <div
              className={`${registrationURL ? 'w-[48%]' : 'w-[100%]'} mx-auto h-52`}
            >
              <GradientEntryButton
                entryUrl={entryURL}
                id={ENTRY_BUTTON_ID.COMPANY_ENTRY_SP}
                size={ENTRY_BUTTON_TEXT_SIZE.MD}
                className="w-full h-full"
                withShadow
                companyId={companyId}
                companyName={companyName}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
